import { useRef, useCallback } from 'react';

export function useMagnetic(strength = 0.28) {
  const ref = useRef(null);

  const onMouseMove = useCallback((e) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    const cx = rect.left + rect.width  / 2;
    const cy = rect.top  + rect.height / 2;
    const dx = (e.clientX - cx) * strength;
    const dy = (e.clientY - cy) * strength;
    el.style.transform    = `translate(${dx}px, ${dy}px)`;
    el.style.transition   = 'transform 0.1s ease';
  }, [strength]);

  const onMouseLeave = useCallback(() => {
    const el = ref.current;
    if (!el) return;
    el.style.transform  = 'translate(0, 0)';
    el.style.transition = 'transform 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275)';
  }, []);

  return { ref, onMouseMove, onMouseLeave };
}
